import { render, staticRenderFns } from "./asyncComponent.vue?vue&type=template&id=517635fe&"
import script from "./asyncComponent.vue?vue&type=script&lang=js&"
export * from "./asyncComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports